import { v4 as uuid } from 'uuid';

export function dispatchSessionError () {
    console.log('dispatchSessionError()');
    this.error = {
        code: 'TOKEN_EXPIRED',
        title: 'Token has expired.',
        message: 'Authorization token has expired. Please login again.',
    };
    this.observed.error = uuid();
}

export default dispatchSessionError;
